// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__1Nwdl","empty":"ModalGraph_empty__A7lI7"};